var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRechargeWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 9C10.668 9.55227 11.1157 10 11.668 10C12.2203 10 12.668 9.55227 12.668 9C12.668 8.44773 12.2203 8 11.668 8C11.1157 8 10.668 8.44773 10.668 9Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33466 7.33333C1.33466 4.81917 1.33466 3.5621 2.11571 2.78105C2.89676 2 4.15384 2 6.66802 2H9.33469C9.95462 2 10.2646 2 10.519 2.06815C11.2092 2.25308 11.7482 2.79218 11.9332 3.48236C12.0014 3.73669 12.0014 4.04669 12.0014 4.66667M6.66802 4.66667H10.668C12.5536 4.66667 13.4964 4.66667 14.0822 5.25245C14.668 5.83824 14.668 6.78107 14.668 8.66667V10C14.668 11.8856 14.668 12.8284 14.0822 13.4142C13.4964 14 12.5536 14 10.668 14H8.33369",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 11.3337H3.99998M3.99998 11.3337H1.33331M3.99998 11.3337V14.0003M3.99998 11.3337V8.66699",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeWallet);
export default __webpack_public_path__ + "static/media/recharge-wallet.943764c2980df2e36bb52cc2ef259fee.svg";
export { ForwardRef as ReactComponent };